/* eslint-disable */
/**
 * Implement Google Analytics Snippets.
 *
 * The injected snippets are consitent for all Everest verticals. Choosi (white
 * label) and CTM have separate IDs.
 */

import { pageContext } from 'ctm-util-functions';

const everestTheme = pageContext.getProps().everestTheme;

const propertyIdMap = {
    nonProd: {
        ctm: {
            SentryKey: '54193cf095054d27a674026aa87fbd00',
            SentryApp: '138712'
        },
        choo: {
            SentryKey: '54193cf095054d27a674026aa87fbd00',
            SentryApp: '138712'
        },
        islt: {
            SentryKey: '54193cf095054d27a674026aa87fbd00',
            SentryApp: '138712'
        }
    },

    prod: {
        ctm: {
            SentryKey: 'a99290fffd024202b5843d4634464468',
            SentryApp: '138729'
        },
        choo: {
            SentryKey: 'a99290fffd024202b5843d4634464468',
            SentryApp: '138729'
        },
        islt: {
            SentryKey: 'a99290fffd024202b5843d4634464468',
            SentryApp: '138729'
        }
    }
};

const envKey = process.env.EVEREST_DEPLOY_ENV?.trim() === 'prod' ? 'prod' : 'nonProd';

const SentryScript = (properties) => {
    properties.sentryKey = propertyIdMap[envKey][everestTheme].SentryKey;
    properties.sentryApp = propertyIdMap[envKey][everestTheme].SentryApp;
    const baseAssetsPath = pageContext.getProps().models.pageSchemaModel.getBaseAssetsPath();
    properties.bundleUrl = `${baseAssetsPath}/lib/min/sentry-bundle.min.js`;
    // This script is the javascript loader as per the Client Keys section of the SDK Setup (Sentry.io)
    // <script src='https://js.sentry-cdn.com/54193cf095054d27a674026aa87fbd00.min.js' crossorigin="anonymous"></script>
    // Scripts have been stored locally rather than relying on loading from external sources.
    return `(function(c,u,v,n,p,e,z,A,w){function k(a){if(!x){x=!0;var l=u.getElementsByTagName(v)[0],d=u.createElement(v);d.src=A;d.crossorigin="anonymous";d.addEventListener("load",function(){try{c[n]=r;c[p]=t;var b=c[e],d=b.init;b.init=function(a){for(var b in a)Object.prototype.hasOwnProperty.call(a,b)&&(w[b]=a[b]);d(w)};B(a,b)}catch(g){console.error(g)}});l.parentNode.insertBefore(d,l)}}function B(a,l){try{for(var d=m.data,b=0;b<a.length;b++)if("function"===typeof a[b])a[b]();var e=!1,g=c.__SENTRY__;"undefined"!==
            typeof g&&g.hub&&g.hub.getClient()&&(e=!0);g=!1;for(b=0;b<d.length;b++)if(d[b].f){g=!0;var f=d[b];!1===e&&"init"!==f.f&&l.init();e=!0;l[f.f].apply(l,f.a)}!1===e&&!1===g&&l.init();var h=c[n],k=c[p];for(b=0;b<d.length;b++)d[b].e&&h?h.apply(c,d[b].e):d[b].p&&k&&k.apply(c,[d[b].p])}catch(C){console.error(C)}}for(var f=!0,y=!1,q=0;q<document.scripts.length;q++)if(-1<document.scripts[q].src.indexOf(z)){f="no"!==document.scripts[q].getAttribute("data-lazy");break}var x=!1,h=[],m=function(a){(a.e||a.p||a.f&&
            -1<a.f.indexOf("capture")||a.f&&-1<a.f.indexOf("showReportDialog"))&&f&&k(h);m.data.push(a)};m.data=[];c[e]=c[e]||{};c[e].onLoad=function(a){h.push(a);f&&!y||k(h)};c[e].forceLoad=function(){y=!0;f&&setTimeout(function(){k(h)})};"init addBreadcrumb captureMessage captureException captureEvent configureScope withScope showReportDialog".split(" ").forEach(function(a){c[e][a]=function(){m({f:a,a:arguments})}});var r=c[n];c[n]=function(a,e,d,b,f){m({e:[].slice.call(arguments)});r&&r.apply(c,arguments)};
            var t=c[p];c[p]=function(a){m({p:a.reason});t&&t.apply(c,arguments)};f||setTimeout(function(){k(h)})})(window,document,"script","onerror","onunhandledrejection","Sentry","${
                properties.sentryKey
            }","${properties.bundleUrl}",{"dsn":"https://${properties.sentryKey}@o65279.ingest.sentry.io/${properties.sentryApp}"});`;
};
const SentryScriptOnLoad = (properties) => {
    // Load in additional configuration options not generated by the default javascript loader above.
    return `Sentry.onLoad(function(){
        Sentry.init({
            release: "${process.env.appVersion}",
            environment: "${process.env.EVEREST_DEPLOY_ENV}",
            maxBreadcrumbs: 30,
            ignoreErrors: [],
            ignoreUrls: [],
            debug: ${process.env.EVEREST_DEPLOY_ENV?.trim() === 'local' ? 'true' : 'false'}
        });
    });`;
};

const favIcon = () => {
    const baseAssetsPath = pageContext.getProps().models.pageSchemaModel.getBaseAssetsPath();
    const brandCode = process.env.EVEREST_THEME?.trim();
    let faviconPath = `${baseAssetsPath}/brand/${brandCode}/images/`;
    return `<link rel="icon" href="${faviconPath}favicon.ico">`;
};

const AppleTouchIcon = (properties) => {
    const baseAssetsPath = pageContext.getProps().models.pageSchemaModel.getBaseAssetsPath();
    const brandCode = process.env.EVEREST_THEME?.trim();
    let touchIconPath = `${baseAssetsPath}/brand/${brandCode}/images/`;
    const sizesProp = properties.size ? ` sizes="${properties.size}"` : '';
    return `<link rel="apple-touch-icon"${sizesProp} href="${touchIconPath}touch-icons/${properties.image}">`;
};

const polyfillIE = (properties) => {
    const baseAssetsPath = pageContext.getProps().models.pageSchemaModel.getBaseAssetsPath();
    if (properties.folderPath.indexOf(baseAssetsPath) === -1) {
        properties.folderPath = properties.folderPath.replace('/evt/assets', baseAssetsPath);
    }
    return `<script src="${properties.folderPath}/min/polyfill.min.js"></script>`;
};

const newRelicScript = (properties) => {
    const baseAssetsPath = pageContext.getProps().models.pageSchemaModel.getBaseAssetsPath();
    return `<script src="${baseAssetsPath}/dist/nr-header.js"></script>`;
};

const requestAnimationFrame = (properties) => {
    const baseAssetsPath = pageContext.getProps().models.pageSchemaModel.getBaseAssetsPath();
    if (properties.folderPath.indexOf(baseAssetsPath) === -1) {
        properties.folderPath = properties.folderPath.replace('/evt/assets', baseAssetsPath);
    }
    return `<script src="${properties.folderPath}/min/requestAnimationFrame.min.js"></script>`;
};

const unsupportedBrowser = (properties) => {
    return `var $buoop = {
                vs: {
                    i: ${properties.i},
                    f: ${properties.f},
                    o: ${properties.o},
                    s: ${properties.s},
                    c: ${properties.c}
                },
                test: ${properties.test},
                reminder: ${properties.reminder},
                noclose: ${properties.noclose},
                api: 4
            };

            function $buo_f() {
                var e = document.createElement("script");
                e.src = "//browser-update.org/update.min.js";
                document.body.appendChild(e);
            };
            try {
                document.addEventListener("DOMContentLoaded", $buo_f,false);
            } catch(e) {
                window.attachEvent("onload", $buo_f);
            }
    `;
};

const SnippetTemplates = {
    SentryScript,
    SentryScriptOnLoad,
    favIcon,
    AppleTouchIcon,
    polyfillIE,
    newRelicScript,
    requestAnimationFrame,
    unsupportedBrowser
};

export { SnippetTemplates };
